import { useEffect, useState } from "react";
import { Check, CheckCircle2, Download, FileArchive, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { studio, apiError, beDate, btnGhost, API } from "@/lib/studioApi";
import { SectionCard } from "@/components/studio/StudioUI";

/* Exports envoyés au comptable : téléchargement + « Marquer comme reçu » (côté comptable). */
export const AccountantExports = () => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => { studio.get("/accounting/exports").then(({ data }) => setItems(data.items || [])).catch(() => setItems([])); }, []);

  const received = async (x) => {
    setBusy(x.id);
    try {
      const { data } = await studio.post(`/accounting/exports/${x.id}/received`);
      setItems((l) => l.map((i) => (i.id === x.id ? { ...i, ...data } : i)));
      toast.success(`Export ${x.label} marqué comme reçu : l'entreprise est prévenue.`);
    } catch (e) { toast.error(apiError(e, "Action impossible.")); } finally { setBusy(""); }
  };

  if (!items?.length) return null;
  return (
    <SectionCard
      testId="accountant-exports"
      className="mt-6"
      title={<span className="inline-flex items-center gap-2"><FileArchive className="h-4 w-4 text-[#3A5CC8]" /> Exports envoyés par l'entreprise</span>}
      hint="ZIP du trimestre (CSV + UBL), lien valable 90 jours. Confirmez la réception pour prévenir l'entreprise."
    >
      <div className="divide-y divide-[#EDEFF7]">
        {items.slice(0, 8).map((x) => (
          <div key={x.id} data-testid={`accountant-export-row-${x.id}`} className="flex flex-wrap items-center justify-between gap-2 py-2.5 text-sm">
            <div className="min-w-0">
              <p className="font-semibold text-[#0F2645]">{x.label} <span className="font-normal text-[#93A0BC]">· {beDate(x.start)} → {beDate(x.end)}</span></p>
              <p className="text-xs text-[#5C6A87]">Envoyé le {beDate(x.created_at)} ({x.source === "auto" ? "automatique" : "manuel"}){x.received_at ? ` · reçu le ${beDate(x.received_at)}` : ""}</p>
            </div>
            <div className="flex items-center gap-2">
              <a href={`${API}/export-comptable/${x.token}`} target="_blank" rel="noreferrer" data-testid={`accountant-export-zip-${x.id}`} className={`${btnGhost} min-h-[36px] px-3 text-xs`}><Download className="h-3.5 w-3.5" /> ZIP</a>
              {x.received_at ? (
                <span data-testid={`accountant-export-received-${x.id}`} className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-700"><CheckCircle2 className="h-3.5 w-3.5" /> Reçu</span>
              ) : (
                <button type="button" data-testid={`accountant-export-mark-${x.id}`} disabled={busy === x.id} onClick={() => received(x)} className="inline-flex min-h-[36px] items-center gap-1.5 rounded-xl bg-[#0F2645] px-3 text-xs font-semibold text-white hover:bg-[#1B3561] disabled:opacity-40">
                  {busy === x.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />} Marquer comme reçu
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};
